<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Refund Request Form</h1>
<div mat-dialog-content>
    <form [formGroup]="refundRequestForm" (ngSubmit)="onSubmit()" *ngIf="refundRequestForm">
        <div class="delivery-colle-data-box">
            <fieldset>
                <legend>Refund Request:</legend>

                <div class="grid-element-full">
                    <label for="plusValue">Request Name{{ refundRequestForm.get("plusValue") | required }}</label>
                    <textarea formControlName="requestText" rows="2" placeholder="request message"></textarea>
                    <app-error-html-handler [ctrl]="refundRequestForm.get('requestText')" [messages]="formValidationMsgs.requestText"></app-error-html-handler>
                </div>

                <div class="col-48 grid-element">
                    <label for="plusValue">monetary value{{ refundRequestForm.get("plusValue") | required }}</label>
                    <input type="text" name="plusValue" formControlName="plusValue">
                    <app-error-html-handler [ctrl]="refundRequestForm.get('plusValue')" [messages]="formValidationMsgs.plusValue"></app-error-html-handler>
                </div>

                <div class="col-48 grid-element">
                    <label>Reciept{{ refundRequestForm.get("receipt") | required }}</label>
                    <input type="file" name="receipt" (change)="onFileSelect($event)" accept="image/png, image/jpeg, image/jpg, image/gif"/>
                    <app-error-html-handler [ctrl]="refundRequestForm.get('receipt')" [messages]="formValidationMsgs.receipt"></app-error-html-handler>
                </div>
            </fieldset>
        </div>    

        <div class="center mt-20">
            <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="disableBtn || !refundRequestForm.valid">
            Salva <i class="ml-10 far fa-save"></i>
            </button>
        </div>
    </form>
</div>